/**
 * Extended color palette for charts with many series
 */
export const EXTENDED_CHART_COLORS = [
  'var(--brand-500)', // Blue
  'hsl(160, 60%, 45%)', // Teal
  'hsl(280, 65%, 60%)', // Purple
  'hsl(340, 75%, 55%)', // Pink
  'hsl(25, 75%, 55%)', // Orange
  'hsl(45, 90%, 55%)', // Yellow
  'hsl(120, 50%, 50%)', // Green
  'hsl(190, 70%, 50%)', // Cyan
  'hsl(10, 70%, 55%)', // Red
  'hsl(260, 60%, 55%)', // Violet
] as const;

/**
 * Brand color for primary data series
 */
export const BRAND_COLOR = 'var(--color-brand-500)';

/**
 * Default animation configuration
 */
export const DEFAULT_ANIMATION = {
  enabled: true,
  duration: 300,
  easing: 'ease-in-out' as const,
};

/**
 * Default chart dimensions
 */
export const DEFAULT_CHART_HEIGHT = 256; // 64 * 4 = 16rem

/**
 * Default axis configuration
 */
export const DEFAULT_AXIS_CONFIG = {
  show: true,
  tickLine: false,
  axisLine: false,
  tickMargin: 8,
};

/**
 * Default legend configuration
 */
export const DEFAULT_LEGEND_CONFIG = {
  position: 'bottom' as const,
  align: 'center' as const,
  verticalAlign: 'bottom' as const,
};

/**
 * Empty state messages
 */
export const EMPTY_STATES = {
  noData: 'No data available',
  comingSoon: 'Coming soon',
  selectDateRange: 'Select a date range to view data',
  insufficientData: 'Insufficient data to display chart',
} as const;

/**
 * Loading skeleton heights for different chart types
 */
export const SKELETON_HEIGHTS = {
  metric: 120,
  bar: 256,
  line: 256,
  area: 256,
  pie: 280,
} as const;

/**
 * Responsive breakpoints (matches Tailwind defaults)
 */
export const BREAKPOINTS = {
  'sm': 640,
  'md': 768,
  'lg': 1024,
  'xl': 1280,
  '2xl': 1536,
} as const;

/**
 * Number formatting thresholds
 */
export const FORMAT_THRESHOLDS = {
  thousand: 1000,
  million: 1000000,
  billion: 1000000000,
} as const;

/**
 * Default currency code
 */
export const DEFAULT_CURRENCY = 'USD';

/**
 * Default locale for formatting
 */
export const DEFAULT_LOCALE = 'en-US';
